import axios from 'axios';

const backend_url = process.env.REACT_APP_BACKEND_URL;

// Create axios instance with default config
const instance = axios.create({
  baseURL: backend_url,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor for authentication
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // if (error.response?.status === 401) {
    //   // Clear auth data
    //   localStorage.removeItem('token');
    //   localStorage.removeItem('admin');
    //   localStorage.removeItem('rowsPerPage');
    //   window.location.href = '/admin-app/login';
    // }
    // Handle network errors
    if (error.code === 'ERR_NETWORK') {
      console.error('Network error:', error);
      return Promise.reject({
        message: 'Unable to connect to the server. Please check your internet connection.'
      });
    }
    return Promise.reject(error);
  }
);

export default instance; 
